const undeleteSlide = (slideId) => {
  const target = document.querySelector(`#page-thumb-container-with-index-${slideId}`);
  if (!target) return;

  target.dataset.isDeleted = false;
  window.hideContextMenus();
};

export default undeleteSlide;
